import { useUserStore } from '../stores/UserStore';
import type { UserNotification } from '../types/local';
import { trcpProxyClient, trpc } from '../utils/trcp';

interface Response {
	data: UserNotification[];
	refetch: () => Promise<UserNotification[]>;
	addNewNotification: (notification: UserNotification) => void;
	onNotificationRead: (id: string) => void;
	readNotification: (id: string) => Promise<void>;
}

export const useNotifications = (): Response => {
	const notifications = useUserStore(state => state.notifications);
	const readNotificationStore = useUserStore(state => state.readNotification);
	const setNotifications = useUserStore(state => state.setNotifications);
	const readNotificationTrpc = trpc.user.readNotification.useMutation();

	const refetch = async () => {
		const data = await trcpProxyClient.user.getNotifications.query();
		setNotifications(data);

		return data;
	};

	const readNotification = async (id: string) => {
		await readNotificationTrpc.mutateAsync({ id });
	};

	const onNotificationRead = (id: string) => {
		readNotificationStore(id);
	};

	const addNewNotification = (notification: UserNotification) => {
		setNotifications([...notifications, notification]);
	};

	return { data: notifications, refetch, addNewNotification, onNotificationRead, readNotification };
};
